import ReplaceNewUser from './ReplaceNewUserContainer';
export default ReplaceNewUser;
